import { setElementInnerHTML } from '../ui_utils/DomUtils.ts';
export class UIRoomCenterSettingsMaxPlayersView {
    setMaxPlayerCount(currentPlayerCount, gameModeMaxPlayerCount) {
        setElementInnerHTML(this.maxPlayersInput, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: `${currentPlayerCount}/${gameModeMaxPlayerCount}`
            }
        });
    }
    constructor(container){
        this.container = container;
        this.maxPlayersInput = container.querySelector('#room_center_maxplayers_settings_input');
        this.maxPlayersRightArrow = container.querySelector('#maxplayers_settings_right_arrow');
        this.maxPlayersLeftArrow = container.querySelector('#maxplayers_settings_left_arrow');
        this.maxPlayersDivBody = container.querySelector('#maxplayers_settings_body');
        const maxPlayersInfo = document.getElementById('maxplayers_settings_speed_info');
        maxPlayersInfo.hidden = true;
    }
}
